import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';
import { StepHeader } from '@bingads-webui-campaign-react/pmax-common';
import { getFallbackEstimates } from '@bingads-webui-campaign-react/pmax-lite-data';

import { getBudgetStepStyles } from './budget-step-styles';
import { BudgetForm } from './components/budget-form';
import { useBudgetInstrument } from './use-budget-instrument';
import { formatBudgetSuggestionPayload } from './utils/budget-suggestion-helper';

export const BudgetStep = ({
  data,
  // error,
  onDataChange,
  hideStepInfo,
  hideBidStrategy,
  hideCurrencyDropdown,
}) => {
  const getStyles = useResponsiveStyles(getBudgetStepStyles);
  const logger = useBudgetInstrument();

  const [budgetSuggestion, setBudgetSuggestion] = useState();

  useEffect(() => {
    const budgetSuggestionPayload = _.get(data, 'budgetSuggestionPayload');
    const currency = _.get(data, 'currency');
    const budgetSuggestionCurrency = _.get(budgetSuggestion, 'Currency');
    const payload = formatBudgetSuggestionPayload({ ...budgetSuggestionPayload, currency });
    const payloadCurrency = _.get(payload, 'currency');

    if (budgetSuggestionCurrency !== payloadCurrency) {
      const fallbackEstimates = getFallbackEstimates(payloadCurrency);
      setBudgetSuggestion(fallbackEstimates);
    }
  }, [data, budgetSuggestion]);

  return (
    <div className={classNames('budget-step', getStyles('container'))}>
      {!hideStepInfo && <StepHeader
        title={_TL_('What\'s your budget?')}
        description={_TL_('Before you can start running ads for this campaign, please set a budget.')}
      />}
      <div className={classNames(getStyles('budgetContent'))}>
        <BudgetForm
          data={{
            ...data,
            budgetSuggestion,
          }}
          onDataChange={onDataChange}
          logger={logger}
          hideBidStrategy={hideBidStrategy}
          hideCurrencyDropdown={hideCurrencyDropdown}
        />
      </div>
    </div >
  );
};

BudgetStep.propTypes = {
  data: PropTypes.shape({}).isRequired,
  // error: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  hideStepInfo: PropTypes.bool,
  hideBidStrategy: PropTypes.bool,
  hideCurrencyDropdown: PropTypes.bool,
};

BudgetStep.defaultProps = {
  hideStepInfo: false,
  hideBidStrategy: false,
  hideCurrencyDropdown: false,
};
